import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quick-start-progress"
// Polls a Quick Start import until it finishes, then opens the table. A failed import
// stops the polling and reveals the failure panel with the import's message.
export default class extends Controller {
  static targets = ["running", "failed", "failureMessage"]
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    this.poll()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (response.ok) {
        const payload = await response.json()
        if (payload.state === "succeeded") {
          window.location.assign(payload.table_url)
          return
        }
        if (payload.state === "failed") {
          this.showFailure(payload.message)
          return
        }
      }
    } catch (error) {
      // A dropped request is retried on the next tick
      console.warn("Quick Start progress check failed", error)
    }

    this.timer = setTimeout(() => this.poll(), this.intervalValue)
  }

  showFailure(message) {
    this.runningTarget.classList.add("hidden")
    this.failureMessageTarget.textContent = message || "The import failed."
    this.failedTarget.classList.remove("hidden")
  }
}
